import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";
import clientData from "../../../../features/client/forms/client-data";
import './style.css';
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate } from 'react-router-dom';
import { createClientService } from "../../../../features/client/service/client-service";
import { fetchPlansService } from "../../../../features/plans/service/plan-service";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import InfoComponent from "../../../../components/info/info";

export function AddClient() {
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();

    const handleCreateClient = async (formData: any) => {
        if(!formData) {
            showAlert('Dados inválidos', SEVERITY.ERROR);
            return;
        }
        
        if(formData) {
            const response = await createClientService(formData);

            if(response) {
                showAlert('Cliente criado com sucesso', SEVERITY.SUCCESS);
                navigate('/clientes');
            } 

            if(!response) {
                showAlert('Erro ao criar cliente', SEVERITY.ERROR);
            }
        }
    };

    const fetchPlansData = useCallback(async () => {
        try {
            const plans = await fetchPlansService();
            const plansOptions = plans?.map(({ name, id}: any) => ({ label: name, value: id }));

            setFormData(clientData(undefined, undefined, plansOptions));
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        fetchPlansData();
    }, [fetchPlansData]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Clientes', 'Adicionar cliente']} href={['/clientes', '']} onNavigate={navigate}/>
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleCreateClient}
                            title="Adicionar cliente"
                            onCancel={() => navigate('/clientes', {replace: true})}
                        />
                    </>
                )}
            </div>
        </div>
    );
}